import { render, staticRenderFns } from "./BuyQuantity.vue?vue&type=template&id=0fcd7316&scoped=true"
import script from "./BuyQuantity.vue?vue&type=script&lang=js"
export * from "./BuyQuantity.vue?vue&type=script&lang=js"
import style0 from "./BuyQuantity.vue?vue&type=style&index=0&id=0fcd7316&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcd7316",
  null
  
)

export default component.exports